/**
 * Todas as permissões devem estar no enum principal para serem carregadas na inicialização
 */
export enum PermissionResourcesPayRoll {
	VACATION = "res://senior.com.br/analytics/hcm/team/payroll/manager/vacation",
	MY_VACATION = "res://senior.com.br/analytics/hcm/my/payroll/employee/vacation",
	PAYSLIP = "res://senior.com.br/analytics/hcm/employee/payroll/payslip",
	EXPIRING_CONTRACTS = "res://senior.com.br/analytics/hcm/team/payroll/expiringContracts",
	PAYROLL_TOTAL_COST = "res://senior.com.br/analytics/hcm/team/payroll/costOfTeam",
	OVERTIME = "res://senior.com.br/analytics/hcm/team/payroll/overtime",
	PAYROLL_ABSENTEEISM = "res://senior.com.br/hcm/analytics_payroll/dashboard/absenteeism",
}

/**
 * Cards da página Manager, aba PayRoll
 */
export enum PermissionResourcesPayRollManager {
	VACATION = "res://senior.com.br/analytics/hcm/team/payroll/manager/vacation",
	EXPIRING_CONTRACTS = "res://senior.com.br/analytics/hcm/team/payroll/expiringContracts",
	PAYROLL_TOTAL_COST = "res://senior.com.br/analytics/hcm/team/payroll/costOfTeam",
	OVERTIME = "res://senior.com.br/analytics/hcm/team/payroll/overtime",
	PAYROLL_ABSENTEEISM = "res://senior.com.br/hcm/analytics_payroll/dashboard/absenteeism",

}

/**
 * Cards da página My, aba PayRoll
 */
export enum PermissionResourcesPayRollMy {
	PAYSLIP = "res://senior.com.br/analytics/hcm/employee/payroll/payslip",
	MY_VACATION = "res://senior.com.br/analytics/hcm/my/payroll/employee/vacation",
	PAYROLL_ABSENTEEISM = "res://senior.com.br/hcm/analytics_payroll/dashboard/absenteeism",
}
